var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20055_7853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 1.20001C6.04374 1.20001 1.19922 6.04499 1.19922 12C1.19922 17.955 6.04374 22.8 11.9992 22.8C17.9547 22.8 22.7992 17.955 22.7992 12C22.7992 6.04499 17.9547 1.20001 11.9992 1.20001ZM11.9992 21.9C6.54033 21.9 2.0992 17.4589 2.0992 12C2.0992 6.54112 6.54033 2.1 11.9992 2.1C17.4581 2.1 21.8992 6.54112 21.8992 12C21.8992 17.4589 17.4581 21.9 11.9992 21.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7697 11.5796L9.76975 7.07959C9.61642 6.97951 9.41819 6.97412 9.25998 7.06103C9.09883 7.14892 8.99922 7.31692 8.99922 7.50001V16.5C8.99922 16.6831 9.09883 16.8511 9.25998 16.939C9.33419 16.9795 9.4172 17 9.49924 17C9.59299 17 9.68772 16.9736 9.76975 16.9204L16.7697 12.4204C16.9123 12.3287 16.9992 12.1699 16.9992 12C16.9992 11.8301 16.9123 11.6714 16.7697 11.5796ZM9.9992 15.584V8.41604L15.5744 12L9.9992 15.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 1.20001C6.04374 1.20001 1.19922 6.04499 1.19922 12C1.19922 17.955 6.04374 22.8 11.9992 22.8C17.9547 22.8 22.7992 17.955 22.7992 12C22.7992 6.04499 17.9547 1.20001 11.9992 1.20001ZM11.9992 21.9C6.54033 21.9 2.0992 17.4589 2.0992 12C2.0992 6.54112 6.54033 2.1 11.9992 2.1C17.4581 2.1 21.8992 6.54112 21.8992 12C21.8992 17.4589 17.4581 21.9 11.9992 21.9Z",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7697 11.5796L9.76975 7.07959C9.61642 6.97951 9.41819 6.97412 9.25998 7.06103C9.09883 7.14892 8.99922 7.31692 8.99922 7.50001V16.5C8.99922 16.6831 9.09883 16.8511 9.25998 16.939C9.33419 16.9795 9.4172 17 9.49924 17C9.59299 17 9.68772 16.9736 9.76975 16.9204L16.7697 12.4204C16.9123 12.3287 16.9992 12.1699 16.9992 12C16.9992 11.8301 16.9123 11.6714 16.7697 11.5796ZM9.9992 15.584V8.41604L15.5744 12L9.9992 15.584Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20055_7853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPlay);
export default __webpack_public_path__ + "static/media/new-play.00cf0cf080b356979ec8758d14aa41a1.svg";
export { ForwardRef as ReactComponent };